(() => {
  const roots = document.querySelectorAll("[data-ifs]");
  if (!roots.length) return;

  roots.forEach((root) => {
    const track = root.querySelector("[data-ifs-track]");
    const cards = Array.from(root.querySelectorAll("[data-ifs-card]"));
    if (!track || !cards.length) return;

    let activeIndex = 0;

    const isMobile = () => window.matchMedia("(max-width: 1023px)").matches;
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    const scrollToIndex = (i) => {
      const card = cards[i];
      if (!card) return;
      card.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
    };

    const ensureActiveCircle = (card) => {
      const num = card.getAttribute("data-index") || "";
      let activeNum = card.querySelector(".ifs__num--active");
      if (!activeNum) {
        const el = document.createElement("span");
        el.className = "ifs__num ifs__num--active";
        el.setAttribute("aria-hidden", "true");
        const inner = document.createElement("span");
        inner.className = "ifs__num-text";
        inner.textContent = num;
        el.appendChild(inner);
        card.insertBefore(el, card.firstChild);
        activeNum = el;
      } else {
        const inner = activeNum.querySelector(".ifs__num-text");
        if (inner) inner.textContent = num;
      }
      activeNum.style.display = "";
    };

    const buildThumbFromData = (card, thumbEl) => {
      const src = card.getAttribute("data-thumb-src") || "";
      if (!src) return;

      let img = thumbEl.querySelector("img.ifs__thumb-img");
      if (!img) {
        img = document.createElement("img");
        img.className = "ifs__thumb-img";
        img.setAttribute("loading", "lazy");
        img.setAttribute("width", "140");
        img.setAttribute("height", "140");
        img.setAttribute("alt", "");
        thumbEl.insertBefore(img, thumbEl.firstChild);
      }
      img.src = src;
      img.style.opacity = "";
    };

    const ensureThumb = (card) => {
      const num = card.getAttribute("data-index") || "";
      let thumb = card.querySelector(".ifs__thumb");
      if (!thumb) {
        const el = document.createElement("span");
        el.className = "ifs__thumb";
        el.setAttribute("aria-hidden", "true");

        const t = document.createElement("span");
        t.className = "ifs__num-text ifs__num-text--thumb";
        t.textContent = num;

        el.appendChild(t);
        card.insertBefore(el, card.firstChild);
        thumb = el;
      } else {
        const t = thumb.querySelector(".ifs__num-text--thumb");
        if (t) t.textContent = num;
      }

      buildThumbFromData(card, thumb);
      thumb.style.display = "";
    };

    const setActive = (index1Based) => {
      activeIndex = clamp(Number(index1Based) - 1, 0, cards.length - 1);
      const mobile = isMobile();

      cards.forEach((card, i) => {
        const isActive = i === activeIndex;

        card.classList.toggle("is-active", isActive);
        card.classList.toggle("is-inactive", !isActive);
        card.setAttribute("aria-pressed", isActive ? "true" : "false");

        if (mobile) {
          ensureActiveCircle(card);
          const thumb = card.querySelector(".ifs__thumb");
          if (thumb) thumb.style.display = "none";
        } else {
          if (isActive) {
            ensureActiveCircle(card);
            const thumb = card.querySelector(".ifs__thumb");
            if (thumb) thumb.style.display = "none";
          } else {
            const activeNum = card.querySelector(".ifs__num--active");
            if (activeNum) activeNum.style.display = "none";
            ensureThumb(card);
          }
        }
      });

      if (mobile) scrollToIndex(activeIndex);
    };

    cards.forEach((card) => {
      card.addEventListener("click", () => {
        setActive(card.getAttribute("data-index"));
      });

      card.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setActive(card.getAttribute("data-index"));
        }
      });
    });

    const syncByScroll = () => {
      if (!isMobile()) return;
      const left = track.scrollLeft;

      let best = 0;
      let bestDist = Infinity;

      cards.forEach((card, i) => {
        const dist = Math.abs(card.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });

      if (best !== activeIndex) setActive(String(best + 1));
    };

    let ticking = false;
    track.addEventListener("scroll", () => {
      if (!isMobile()) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        syncByScroll();
      });
    });

    window.addEventListener("resize", () => {
      if (isMobile()) syncByScroll();
    });

    const first = cards[0]?.getAttribute("data-index");
    if (first) setActive(first);
  });
})();
